import { ClientFlagsProvider } from '@sdk/session/ClientFlagsContext';

import { Inner } from './Inner';
import { Props } from './types';

export const DontAskMeAgain = ({ about, currentUser }: Props) => (
  <ClientFlagsProvider>
    <Inner about={about} currentUser={currentUser} />
  </ClientFlagsProvider>
);
